import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './App.css';
import translations from './translations.js';
import engineData from './engineData.js';
import logo from './assets/fuso-logo.svg';
import fusotransparent from './assets/fuso-transparent.svg';
// import mainChatImg from './assets/mainChatImg.svg';
import sendIcon from './assets/send-icon.svg';
import chevronRight from './assets/chevron-right.svg';
import chevronLeft from './assets/chevron-left.svg';
import Markdown from 'markdown-to-jsx';
import FeedbackLink from "./feedbackButton/feedbackButton";
import AddInfoButton from "./addInfoButton/addInfoButton";
import ManualCoverage from "./manualCoverage/manualCoverage";
import LazyTurnMedia from "./components/LazyTurnMedia";
import ProfilePhoto from "./profilePhoto/profilePhoto.js";
import userImage from './assets/user.png'
import LanguageDropDown from "./languageDropDown/dropDown.js";
import ImageModal from './imageModal/imageModal.js';
import { Tooltip } from '@chakra-ui/react';
import { ChakraProvider } from '@chakra-ui/react';
import UserHistory from "./userHistory/userHistory.js";
import { useToast } from '@chakra-ui/react'
import { Modal, ModalOverlay, ModalContent, ModalFooter, ModalBody, ModalCloseButton, useDisclosure, Button, Textarea } from '@chakra-ui/react'
import Dictaphone from "./speechRecognition/speechRecognition.js";
import CustomSelect from "./customSelect/customSelect.js";
import { useAdmin } from './context/AdminContext';
import { modelLabel, orderedCaseIds, makeMessageId, manualRefs, dedupeManuals, dedupeImages, postChatStream } from './messageUtils.js';
const SERVER_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000/' : '/api/';
const CHAT_SERVER_URL = SERVER_URL + 'chat';
const HISTORY_SERVER_URL = SERVER_URL + 'history';
const HISTORY_TURN_URL = SERVER_URL + 'history/turn';
const FEEDBACK_SERVER_URL = SERVER_URL + 'feedback';
const SPEECH_SERVER_URL = SERVER_URL + 'speech';
const VEHICLE_DATA_URL = SERVER_URL + 'vehicle-data';
const MODEL_YEARS_URL = SERVER_URL + 'model-years';
// const accessToken = sessionStorage.getItem('chat-bot')?.replace(/^"|"$/g, '')

// Icons for the quick-suggestion chips. Inline SVGs with stroke=currentColor so
// they take the chip's text/hover color. Order matches the backend's suggestion
// list: define / causes / past cases; the "manuals" action always gets the book.
const SUGGESTION_ASK_ICONS = [
  // help-circle — "what does this code indicate?"
  <svg key="help" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>,
  // zap — causes and solutions
  <svg key="zap" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>,
  // clock — past cases
  <svg key="clock" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>,
];
const SUGGESTION_MANUALS_ICON = (
  // book-open — search the maintenance manuals
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);
const suggestionChipIcon = (suggestion, askIndex) =>
  suggestion.action === 'manuals'
    ? SUGGESTION_MANUALS_ICON
    : SUGGESTION_ASK_ICONS[askIndex % SUGGESTION_ASK_ICONS.length];

function App() {
  const OverlayTwo = () => (
    <ModalOverlay
      bg='blackAlpha.300'
      backdropFilter='blur(10px) hue-rotate(90deg)'
    />
  )
  const [messages, setMessages] = useState([]);
  const [question, setQuestion] = useState('');
  const [engineFilter, setEngineFilter] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [modelFilter, setModelFilter] = useState('');
  const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese');
  const [response, setResponse] = useState('');
  const [solutions, setSolutions] = useState({});
  const [dhdSolutions, setDhdSolutions] = useState({});
  const [dealerSolutions, setDealerSolutions] = useState({});
  const [transcript, setTranscript] = useState('');
  const [selectedCase, setSelectedCase] = useState('');
  const [selectedDhdCase, setSelectedDhdCase] = useState('');
  const [selectedDealerCase, setSelectedDealerCase] = useState('');
  const [showActions, setShowActions] = useState(false);
  const [isAwaitingResponse, setIsAwaitingResponse] = useState(false);
  const [isStreaming, setIsStreaming] = useState(false);
  const [turnStatus, setTurnStatus] = useState('Thinking');
  // The turn the input belongs to: an older turn still loading its pages must
  // not touch the screen state of the question asked after it.
  const latestTurn = useRef(null);
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [engineModels, setEngineModels] = useState([]);
  const [models, setModels] = useState([]);
  // { "Light Duty Trucks": ["2017", ...], ... } discovered from blob storage
  const [yearsByModel, setYearsByModel] = useState({});
  const [accessToken, setAccessToken] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [isBotLooking, setIsBotLooking] = useState(false);
  const [hasCopied, setHasCopied] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [historyMessages, setHistoryMessages] = useState([]);
  const messageSection = useRef(null);
  const toast = useToast({ position: 'top-right' })
  const [childFunc, setChildFunc] = useState(null);
  const [removeChatFunc, setRemoveChatFunc] = useState([]);
  const [audioSrc, setAudioSrc] = useState(null);
  const audioRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [speechPlay, setSpeechPlay] = useState(false);
  const [speechSpinner, setSpeechSpinner] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isYearGuideOpen, onOpen: openYearGuide, onClose: closeYearGuide } = useDisclosure()

  // Check if user is admin using context
  const { isAdmin } = useAdmin();
  const [overlay, setOverlay] = React.useState(<OverlayTwo />)
  const [feedback, setFeedback] = useState('');
  const [responseVote, setResponseVote] = useState('');
  // The assistant message whose thumb opened the vote modal — the vote is
  // recorded against THIS answer, not whatever answer happens to be latest.
  const [voteTarget, setVoteTarget] = useState(null);
  const [isSubmittingVote, setIsSubmittingVote] = useState(false);
  // Synchronous re-entry guard: state updates are async, so a fast double
  // click could otherwise slip a second POST in before the button disables.
  const voteInFlight = useRef(false);
  // { [messageId]: 'up' | 'down' } — answers already voted on this session.
  const [votedMessages, setVotedMessages] = useState({});
  const [conversationId, setConversationId] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const { isOpen: isImageModalOpen, onOpen: openImageModal, onClose: closeImageModal } = useDisclosure();


  useEffect(() => {
    sessionStorage.setItem('langOpt', langOpt);
  }, [langOpt]);

  useEffect(() => {
    // Only a blob: URL (what profilePhoto.js stores) may become an <img src>;
    // anything else in sessionStorage falls back to the default avatar.
    const stored = sessionStorage.getItem('profileImage');
    setProfileImage(stored?.startsWith('blob:') ? stored : userImage);
  }, []);

  useEffect(() => {
    setMessages(historyMessages)
  }, [historyMessages]);

  useEffect(() => {
    console.log("App loaded. Language:", langOpt);
  }, [messages]);


  const attachTurnMedia = (turnId, images, manuals) => {
    setMessages((current) => current.map((message) => (
      message.historyTurn?.turnId === turnId
        ? { ...message, images, manuals, historyTurn: null }
        : message
    )));
  };

  const openHistory = (message) => {
    setSolutions({});
    setDhdSolutions({});
    setDealerSolutions({});
    setSpeechPlay(false);
    setSelectedCase(null);
    setSelectedDhdCase(null);
    setSelectedDealerCase(null);
    const newMessages = message.map((entry) => {
      let assistantResponseContent;
      let assistantImages = [];
      let assistantManuals = [];
      let assistantSuggestions = [];
      let assistantCaseIds = [];
      try {
        const assistantResponseObject =
          typeof entry.AssistantResponse === 'string'
            ? JSON.parse(entry.AssistantResponse)
            : entry.AssistantResponse;
        assistantResponseContent = assistantResponseObject.response;
        // Set images if available
        if (entry.images && entry.images.length > 0) {
          assistantImages = entry.images;
        }
        if (entry.manuals && entry.manuals.length > 0) {
          assistantManuals = entry.manuals;
        }
        // Quick-suggestion chips from a no-match answer are part of the stored
        // payload — without restoring them here they vanish when a chat is
        // reopened from history.
        if (Array.isArray(assistantResponseObject.suggestions)) {
          assistantSuggestions = assistantResponseObject.suggestions;
        }
        assistantCaseIds = [
          ...orderedCaseIds(assistantResponseObject.solutions),
          ...orderedCaseIds(assistantResponseObject.dhd_solutions),
          ...orderedCaseIds(assistantResponseObject.dealer_solutions),
        ];
      } catch (error) {
        console.error('Error parsing AssistantResponse:', error);
        assistantResponseContent = "Error parsing response";
      }

      return [
        { role: 'user', content: entry.UserResponse },
        {
          role: 'assistant',
          content: assistantResponseContent,
          images: assistantImages,
          manuals: assistantManuals,
          suggestions: assistantSuggestions,
          // Stable across reopenings, so the backend dedupes a re-vote on the
          // same stored answer.
          messageId: `${entry.ChatId || ''}|${entry.Timestamp || ''}`,
          question: entry.UserResponse,
          modelFilter: entry.Model || '',
          engineFilter: entry.Engine || '',
          year: entry.Year || '',
          langOpt: langOpt,
          caseIds: assistantCaseIds,
          // Older turns load their images and pages when scrolled into view.
          historyTurn: entry.mediaPending ? { chatId: entry.ChatId, turnId: entry.TurnId } : null,
        },
      ];
    }).flat();

    setHistoryMessages(newMessages);
    setResponse(message[message.length - 1].AssistantResponse.response)
    if (message[message.length - 1].AssistantResponse?.solutions) {
      setSolutions(message[message.length - 1].AssistantResponse.solutions);
    }
    if (message[message.length - 1].AssistantResponse?.dhd_solutions) {
      setDhdSolutions(message[message.length - 1].AssistantResponse.dhd_solutions);
    }
    if (message[message.length - 1].AssistantResponse?.dealer_solutions) {
      setDealerSolutions(message[message.length - 1].AssistantResponse.dealer_solutions);
    }
    setTimeout(() => {
      messageSection.current.scrollTo({
        top: messageSection.current.scrollHeight,
        behavior: 'smooth'
      })
    }, 500);
    setEngineFilter(message[message.length - 1].Engine);
    setModelFilter(message[message.length - 1].Model);
    // Restore the manual-year the chat last used, so a phase-2 conversation
    // reopens in phase-2 mode instead of silently flipping to service-case
    // search. (The year-validation effect clears it if the model's manual
    // years no longer include it.)
    setSelectedYear(message[message.length - 1].Year || '');
    setSelectedChat(message[0].ChatId);
    setTranscript(`**Assistant**: ${message[message.length - 1].AssistantResponse.response}`);
    setShowActions(true);
    setSelectedCase('');
    setSelectedDhdCase('');
    setSelectedDealerCase('');
  }

  // useEffect(() => {
  //   const storedToken = sessionStorage.getItem("chat-bot");
  //   const fetchUserToken = async () => {
  //     try {
  //       const response = await axios.get("/oauth2/auth")
  //       if (response.status === 202) {
  //       } else if (response.response.statusCode === 401) {
  //         console.log("this is unauthorized")
  //       }
  //     } catch (err) {
  //       if (err.status === 401) {
  //         console.log("this is unauthorized")
  //         window.location.reload()
  //       }
  //       console.log(err);
  //     }
  //   }
  //   if (storedToken) {
  //     setAccessToken(storedToken.replace(/^"|"$/g, ''));
  //   } else {
  //     fetchUserToken();
  //   }
  // }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(VEHICLE_DATA_URL);
        if (response.data.valid) {
          setEngineModels(response.data.response.engine_models);
          setModels(response.data.response.models);
        } else {
          console.error("Error fetching vehicle data:", response.statusText);
        }
      } catch (e) {

      }
    };
    fetchOptions();
  }, []);

  // Years available per model are discovered live from blob storage so the
  // dropdown only ever offers years that actually have manuals uploaded.
  useEffect(() => {
    const fetchModelYears = async () => {
      try {
        const response = await axios.get(MODEL_YEARS_URL);
        if (response.data && typeof response.data === 'object') {
          setYearsByModel(response.data);
        }
      } catch (e) {
        console.error("Error fetching model years:", e);
      }
    };
    fetchModelYears();
  }, []);

  // modelFilter holds the Japanese value; map it to the English model name
  // (the key used by the /model-years response) to look up its years.
  const selectedModelEng = models.find((m) => m.valueInJap === modelFilter)?.valueInEng;
  const availableYears = (selectedModelEng && yearsByModel[selectedModelEng]) || [];

  // If the model changes and the previously picked year isn't valid anymore,
  // clear it so we never send a year that has no manuals.
  useEffect(() => {
    if (selectedYear && !availableYears.includes(selectedYear)) {
      setSelectedYear('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelFilter, yearsByModel]);

  const handleBlur = () => {
    setIsBotLooking(false);
  };

  const handleNewChat = () => {
    const newMessages = [];
    resetSectedChat();
    setSelectedCase('');
    setSelectedDhdCase('');
    setSelectedDealerCase('');
    setSelectedChat(null);
    setModelFilter('');
    setEngineFilter('');
    // A leftover year would silently route the new chat's first question to
    // the maintenance manuals (phase 2).
    setSelectedYear('');
    setMessages(newMessages)
    setSpeechPlay(false);
    setConversationId('');
  }

  const handleCopy = () => {
    const solutionText = selectedCase ? '\n\n\n' + solutions[selectedCase] : '';
    const dhdSolutionText = selectedDhdCase ? '\n\n\n' + dhdSolutions[selectedDhdCase] : '';
    const dealerSolutionText = selectedDealerCase ? '\n\n\n' + dealerSolutions[selectedDealerCase] : '';
    navigator.clipboard.writeText(`${response}${solutionText}${dhdSolutionText}${dealerSolutionText}`);
    setHasCopied(true);
    setTimeout(() => setHasCopied(false), 2000); // Reset after 2 seconds
  };

  const handleChange = (e) => {
    if (e.target.value.length > 0) {
      setIsBotLooking(true);
    } else {
      setIsBotLooking(false);
    }
    setQuestion(e.target.value)
  };

  const translate = (text) => {
    if (!text || !translations[text]) return text;
    switch (langOpt) {
      case 'Japanese':
        return translations[text].translationJp || text;
      case 'Indonesian':
        return translations[text].translationIn || text;
      case 'Nepali':
        return translations[text].translationNp || text;
      case 'Sinhala':
        return translations[text].translationSl || text;
      case 'Vietnamese':
        return translations[text].translationVn || text;
      case 'Filipino':
        return translations[text].translationPh || text;
      case 'Bengali':
        return translations[text].translationBd || text;
      case 'English':
      default:
        return translations[text].translationEng || text;
    }
  };

  const cleanTextForSpeech = (text) => {
    return text
      .replace(/[#*・【】]/g, '')
      .replace(/\[.*?\]/g, '')
      .replace(/\n{2,}/g, '\n')
      .replace(/\s{2,}/g, ' ')
      .trim();
  };


  const fetchAudio = async () => {
    try {
      setSpeechSpinner(true);
      const solutionText = selectedCase ? '\n\n\n' + solutions[selectedCase] : '';
      const dhdSolutionText = selectedDhdCase ? '\n\n\n' + dhdSolutions[selectedDhdCase] : '';
      const dealerSolutionText = selectedDealerCase ? '\n\n\n' + dealerSolutions[selectedDealerCase] : '';
      const cleanedText = cleanTextForSpeech(`${response}${solutionText}${dhdSolutionText}${dealerSolutionText}`);
      let body = {
        "text": cleanedText,
        "language": langOpt
      }
      const speechResponse = await axios.post(SPEECH_SERVER_URL, body, { responseType: 'blob' });
      if (speechResponse.status === 200) {
        const blob = new Blob([speechResponse.data], { type: 'audio/wav' });
        const audioURL = URL.createObjectURL(blob);
        setAudioSrc(audioURL);
        if (audioRef.current) {
          setSpeechSpinner(false);
          setSpeechPlay(true)
          audioRef.current.src = audioURL;
          audioRef.current.load();
          audioRef.current.play();
          audioRef.current.onended = handleAudioEnd;
        }
      } else {
        console.error("Error fetching audio:", speechResponse.statusText);
      }
    } catch (error) {
      console.error("Error fetching audio:", error);
    }
  };

  const handleAudioEnd = () => {
    setSpeechPlay(false)
  };

  const handlePause = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      setSpeechPlay(false)
    }
  };

  const triggerChildFunction = (historyResponse) => {
    if (childFunc) {
      childFunc(historyResponse); // Trigger the child's function with new data
    }
  };

  const resetSectedChat = () => {
    if (removeChatFunc) {
      const data = ""
      removeChatFunc(data); // Trigger the child's function with new data
    }
  };

  const handleUserHistory = async (userResponse, assistantResonse) => {
    // Persist ONLY what reopening a chat needs. The old else-branch stringified
    // the whole chat response into one field: phase 1 dragged in up to 30 full
    // case texts, phase 2 (whenever the image gates returned no images) dragged
    // in base64 manual pages. Both blew past Azure Tables' 64 KB per-property
    // limit, create_entity failed, and the turn was never saved at all.
    // Images and manual pages ride in their own fields — blob + table column.
    const body = {
      "Model": modelFilter,
      "Engine": engineFilter,
      // Non-empty Year marks this turn as phase 2 (maintenance manuals).
      "Year": selectedYear || '',
      "UserResponse": userResponse,
      "AssistantResonse": JSON.stringify({
        "response": assistantResonse?.response,
        ...(assistantResonse?.suggestions?.length ? { "suggestions": assistantResonse.suggestions } : {}),
        ...(assistantResonse?.solutions ? { "solutions": assistantResonse.solutions } : {}),
        ...(assistantResonse?.dhd_solutions ? { "dhd_solutions": assistantResonse.dhd_solutions } : {}),
        ...(assistantResonse?.dealer_solutions ? { "dealer_solutions": assistantResonse.dealer_solutions } : {}),
      }),
      "conversation_id": conversationId,
      ...(assistantResonse?.images?.length ? { "img": assistantResonse.images } : {}),
      // Was only sent alongside images, so image-less phase-2 turns lost their
      // manual pages even when the save itself went through.
      ...(assistantResonse?.manuals?.length ? { "manuals": assistantResonse.manuals } : {}),
      ...(selectedChat !== null ? { "ChatId": selectedChat } : {}),
    }

    try {
      const result = await axios.post(HISTORY_SERVER_URL, body);
      if (result.data.valid) {
        if (selectedChat === null) {
          setSelectedChat(result.data.entity.ChatId);
        }
        if (assistantResonse?.images?.length) {
          Object.assign(result.data.entity, { "images": assistantResonse.images })
        }
        if (assistantResonse?.manuals?.length) {
          Object.assign(result.data.entity, { "manuals": assistantResonse.manuals })
        }
        triggerChildFunction(result.data.entity)
      }
    } catch (error) {
      // Saving history is best-effort — the chat itself already succeeded,
      // so a save failure here should never take down the page.
      console.error("Error saving user history:", error);
    }
  }

  // Log a failed turn to history (fire-and-forget) so outages are
  // measurable — until now only successful turns were ever recorded.
  const logFailedTurn = (currentQuestion, errorNotice, error) => {
    try {
      axios.post(HISTORY_SERVER_URL, {
        "Model": modelFilter,
        "Engine": engineFilter,
        "Year": selectedYear || '',
        "UserResponse": currentQuestion,
        "AssistantResonse": JSON.stringify({
          error: true,
          response: errorNotice,
          status: error?.response?.status ?? null,
          message: String(error?.message || error),
        }),
        "conversation_id": conversationId,
        ...(selectedChat !== null && { "ChatId": selectedChat }),
      }).catch(() => { });
    } catch (_) { }
  };

  const handleSendMessage = async (overrideQuestion, suggestionDocs) => {
    // Suggestion chips pass the question to send directly; the send button
    // passes a click event, so only accept explicit strings.
    const outgoingQuestion = typeof overrideQuestion === 'string' ? overrideQuestion : question;
    // A chip also passes the ids of the evidence it was written from, so the
    // backend answers from those pages/cases instead of a fresh search that
    // may miss them.
    const chipEvidence = Array.isArray(suggestionDocs) && suggestionDocs.length
      ? { suggestion_docs: suggestionDocs }
      : {};
    if (!outgoingQuestion.trim()) return;

    // Ensure the model is selected (mandatory)
    if (!modelFilter) {
      toast({
        title: translate('Warning'),
        description: translate('Please select a model before proceeding.'),
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setIsAwaitingResponse(true);
    setTimeout(() => {
      messageSection.current.scrollTo({
        top: messageSection.current.scrollHeight,
        behavior: 'smooth'
      })
    }, 200)

    const currentQuestion = outgoingQuestion;
    setMessages([...messages, { role: 'user', content: currentQuestion }]);
    setQuestion('');
    const filters = selectedYear === ''
      ? { engine_filter: engineFilter, model_filter: modelFilter }
      : { year: selectedYear, model_filter: models.find((model) => model.valueInJap === modelFilter)?.valueInEng || '' };
    const body = {
      ...filters,
      question: currentQuestion,
      lang_opt: langOpt,
      ...chipEvidence,
      ...(conversationId !== '' && { conversation_id: conversationId })
    };
    const turnId = makeMessageId();
    latestTurn.current = turnId;
    const isLatestTurn = () => latestTurn.current === turnId;
    const cleanAnswer = (text) => text.replace(/## Image Summary\s*```json[\s\S]*?```/, '');
    // Everything a vote on this answer needs, captured at answer time so later
    // filter changes or newer answers can't leak into it.
    const answerMessage = {
      role: 'assistant',
      messageId: turnId,
      question: currentQuestion,
      modelFilter: filters.model_filter || '',
      engineFilter: filters.engine_filter || '',
      year: filters.year || '',
      langOpt: langOpt,
    };
    const updateAnswer = (fields) => setMessages((current) => (
      current.some((message) => message.messageId === turnId)
        ? current.map((message) => (message.messageId === turnId ? { ...message, ...fields } : message))
        : [...current, { ...answerMessage, ...fields }]
    ));

    // Live text is painted at most every 80 ms: re-rendering the markdown for
    // every token makes a long answer stutter.
    let liveText = '';
    let paintTimer = null;
    let answerShown = false;
    let casesPublished = false;
    setTurnStatus('Thinking');
    setSolutions({});
    setDhdSolutions({});
    setDealerSolutions({});
    const showCases = (cases) => {
      casesPublished = true;
      setSolutions(cases.solutions || {});
      setDhdSolutions(cases.dhd_solutions || {});
      setDealerSolutions(cases.dealer_solutions || {});
      if (cases.conversation_id) {
        setConversationId(cases.conversation_id);
      }
      // Cases can arrive before any text in a language that is not streamed.
      updateAnswer({ content: liveText, streaming: true, casesReady: true });
      setIsStreaming(true);
    };
    const paintLiveText = () => {
      paintTimer = null;
      if (answerShown) return;
      setIsStreaming(true);
      updateAnswer({ content: liveText, streaming: true });
    };
    // Text is final: the technician can read and ask again while pages load.
    const showAnswer = (answer) => {
      answerShown = true;
      clearTimeout(paintTimer);
      const text = cleanAnswer(answer.response);
      updateAnswer({ content: text, suggestions: answer.suggestions, streaming: false, pagesLoading: true });
      setResponse(text);
      setTranscript(`$**Assistant**: ${text}\n\n`);
      if (answer.conversation_id) {
        setConversationId(answer.conversation_id);
      }
      setIsAwaitingResponse(false);
      setIsStreaming(false);
    };
    try {
      const data = await postChatStream(CHAT_SERVER_URL, body, {
        onDelta: (text) => {
          liveText += text;
          if (paintTimer === null) paintTimer = setTimeout(paintLiveText, 80);
        },
        onAnswer: showAnswer,
        // After the text is final, a status belongs to that answer's page line:
        // the input is free by then, and the next question has its own status.
        onStatus: (label) => (answerShown ? updateAnswer({ pagesStatus: label }) : setTurnStatus(label)),
        onCases: showCases,
      });
      clearTimeout(paintTimer);
      answerShown = true;
      const result = { data };
      const cleanedResponse = cleanAnswer(result.data.response);
      const caseIds = [
        ...orderedCaseIds(result.data?.solutions),
        ...orderedCaseIds(result.data?.dhd_solutions),
        ...orderedCaseIds(result.data?.dealer_solutions),
      ];
      updateAnswer({
        content: cleanedResponse,
        images: result.data?.images,
        manuals: result.data?.manuals,
        suggestions: result.data?.suggestions,
        streaming: false,
        pagesLoading: false,
        caseIds,
        noCases: casesPublished && caseIds.length === 0,
      });
      handleUserHistory(currentQuestion, result.data);
      if (!isLatestTurn()) return;
      setResponse(cleanedResponse);
      setSolutions(result.data?.solutions || {});
      setDhdSolutions(result.data?.dhd_solutions || {});
      setDealerSolutions(result.data?.dealer_solutions || {});
      if (result.data?.conversation_id) {
        setConversationId(result.data.conversation_id);
      }
      setTranscript(`$**Assistant**: ${cleanedResponse}\n\n`);
      setShowActions(true);
      setSelectedCase('');
      setSelectedDhdCase('');
      setSelectedDealerCase('');
    } catch (error) {
      clearTimeout(paintTimer);
      console.error('Error sending message:', error);
      // The answer is on screen; losing its pages must not replace it.
      if (answerShown) {
        updateAnswer({ pagesLoading: false });
        return;
      }
      // A silent failure looks like the bot ignored the question. Show the
      // error in the conversation and as a toast, in the user's language.
      const errorNotice = translate('The chatbot could not process this question. Please try again in a moment.');
      updateAnswer({ content: errorNotice, streaming: false });
      toast({
        title: translate('Error'),
        description: errorNotice,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      logFailedTurn(currentQuestion, errorNotice, error);
    } finally {
      if (isLatestTurn()) {
        setIsAwaitingResponse(false);
        setIsStreaming(false);
      }
      setTimeout(() => {
        messageSection.current.scrollTo({
          top: messageSection.current.scrollHeight,
          behavior: 'smooth'
        })
      }, 200)
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSendMessage();
    }
  };


  const handleFeedbackChange = (event) => {
    setFeedback(event.target.value);
  };

  const openVoteModal = (message, vote) => {
    if (!message || votedMessages[message.messageId] || voteInFlight.current) return;
    setOverlay(<OverlayTwo />)
    setVoteTarget(message);
    setResponseVote(vote);
    onOpen();
  }

  const closeVoteModal = () => {
    // Closing mid-submit would let the user reopen and resend the same vote.
    if (voteInFlight.current) return;
    setFeedback('');
    setVoteTarget(null);
    onClose();
  }

  const handleDownVote = async (event) => {
    if (voteInFlight.current) return;
    if (responseVote === "down") {
      if (feedback.trim() === "") {
        return
      }
    }
    const target = voteTarget;
    if (target?.messageId && votedMessages[target.messageId]) {
      closeVoteModal();
      return;
    }
    voteInFlight.current = true;
    setIsSubmittingVote(true);
    try {
      let body = {
        vote: responseVote,
        // Kept for backward compatibility — now the answer that was voted on,
        // not the latest one.
        transcript: target ? `**Assistant**: ${target.content}` : transcript,
        feedback: feedback,
        question: target?.question || '',
        model_filter: target?.modelFilter || '',
        engine_filter: target?.engineFilter || '',
        year: target?.year || '',
        lang_opt: target?.langOpt || langOpt,
        case_ids: target?.caseIds || [],
        manual_refs: manualRefs(target?.manuals),
        message_id: target?.messageId || '',
      }
      await axios.post(FEEDBACK_SERVER_URL, body);
      if (target?.messageId) {
        setVotedMessages((prev) => ({ ...prev, [target.messageId]: responseVote }));
      }
      toast({
        title: translate('Feedback created'),
        description: translate("Feedback Shared Successfully"),
        status: 'success',
        duration: 1000,
        isClosable: true,
      })
    } catch (error) {
      console.error('Error sending feedback:', error);
    } finally {
      voteInFlight.current = false;
      setIsSubmittingVote(false);
      setFeedback('');
      setVoteTarget(null);
      onClose();
    }
  }


  const handleFeedback = async (vote) => {
    try {
      await axios.post(FEEDBACK_SERVER_URL, { vote, transcript });
      toast({
        title: translate('Feedback created'),
        description: translate("Feedback Shared Successfully"),
        status: 'success',
        duration: 1000,
        isClosable: true,
      })
    } catch (error) {
      console.error('Error sending feedback:', error);
    }
  };

  const handleDownload = () => {
    // Detached anchor: the transcript never enters the page DOM, only a blob download.
    const file = new Blob([transcript], { type: 'text/plain' });
    const url = URL.createObjectURL(file);
    const element = document.createElement("a");
    element.href = url;
    element.download = `chat-${new Date().toISOString()}.txt`;
    element.click();
    // Revoking too early can cancel the download in Safari/Firefox.
    setTimeout(() => URL.revokeObjectURL(url), 40000);
  };


  const selectCase = (caseId) => {
    setSelectedDhdCase(null);
    setSelectedDealerCase(null);
    setSelectedCase((prev) => (prev === caseId ? '' : caseId));
  }

  const selectDhdCase = (caseId) => {
    setSelectedCase(null);
    setSelectedDealerCase(null);
    setSelectedDhdCase((prev) => (prev === caseId ? '' : caseId));
  }

  const selectDealerCase = (caseId) => {
    setSelectedCase(null);
    setSelectedDhdCase(null);
    setSelectedDealerCase((prev) => (prev === caseId ? '' : caseId));
  }

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  }


  // ---------------------------------------------------------
  const [sidebarWidth, setSidebarWidth] = useState(250); // Initial width of sidebar in pixels
  const [isResizing, setIsResizing] = useState(false);
  const sidebarRef = useRef(0);
  const resizerOffset = useRef(0); // Store the mouse offset when clicking the resizer
  const minSidebarWidth = 200;
  const maxSidebarWidth = 1000;


  // Function to handle the start of resizing
  const handleMouseDown = (e) => {
    setIsResizing(true);
    resizerOffset.current = e.clientX - sidebarRef.current.getBoundingClientRect().right;
    e.preventDefault(); // Prevent text selection while dragging
  };

  // Function to handle resizing while moving the mouse
  const handleMouseMove = (e) => {
    if (isResizing) {
      const newWidth = e.clientX - sidebarRef.current.getBoundingClientRect().left - resizerOffset.current - 30;
      if (newWidth >= minSidebarWidth && newWidth <= maxSidebarWidth) {
        setSidebarWidth(newWidth); // Resize the sidebar width
      }
    }
  };

  // Function to stop resizing when mouse is released
  const handleMouseUp = () => {
    if (isResizing) {
      setIsResizing(false);
    }
  };
  useEffect(() => {
    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      // Cleanup in case the component is unmounted while resizing
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing]);


  return (
    <>
      <ChakraProvider resetCSS={false}>
        <Modal isCentered isOpen={isOpen} onClose={closeVoteModal}>
          {overlay}
          <ModalContent>
            <ModalCloseButton isDisabled={isSubmittingVote} />
            <ModalBody>
              <h2 className="feedback-title">{translate("Help us shape a better experience by sharing your feedback!")}</h2>
              <Textarea placeholder={translate("Enter your feedback")} onChange={handleFeedbackChange}></Textarea>
            </ModalBody>
            <ModalFooter>
              <Button onClick={closeVoteModal} mr={3} variant="outline" isDisabled={isSubmittingVote}>{translate('Close')}</Button>
              <Button bg="#e60000" color="white" _hover={{ bg: '#b80000' }} _active={{ bg: '#990000' }} isLoading={isSubmittingVote} isDisabled={isSubmittingVote} onClick={() => handleDownVote()}>{translate('Submit')}</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal isCentered isOpen={isYearGuideOpen} onClose={closeYearGuide}>
          {overlay}
          <ModalContent className="year-guide-modal">
            <ModalCloseButton />
            <ModalBody>
              <h2 className="year-guide-title">{translate("Select the year of the maintenance manual")}</h2>
              <p className="year-guide-body">{translate("Choose a manual year below, then send the question to search the maintenance manuals.")}</p>
            </ModalBody>
            <ModalFooter>
              <Button bg="#e60000" color="white" _hover={{ bg: '#b80000' }} _active={{ bg: '#990000' }} onClick={closeYearGuide}>{translate('Close')}</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </ChakraProvider>
      <div className="App scroll-div">
        <header>
          <img src={logo} alt="Fuso Logo" className="fuso-logo" />
          <div className="header-toolbar">
            {isAdmin && (
              <button className="header-admin-btn" onClick={() => window.location.href = '/admin-dashboard'}>
                {translate("Admin Dashboard")}
              </button>
            )}
            <LanguageDropDown setLanguage={setLangOpt} translate={translate} showAllLanguages={true}></LanguageDropDown>
            <ProfilePhoto translate={translate} />
          </div>
        </header>
        <div className={`content ${langOpt === "English" ? 'jakartaFont' : 'japaneseFont'}`}>
          {sidebarVisible && (
            <aside className="sidebar"
              ref={sidebarRef}
              style={{ width: `${sidebarWidth}px` }}>
              <div className="sidebar-tools">
                <div className="chat-bot">
                  <img className="bot-image" src="./bot1.svg" alt="botImage"></img>
                  <h1>TIC Chatbot</h1>
                </div>
                <div className="sidebar-tool-button">
                  <button className='start-new-btn' style={{ fontSize: langOpt === 'Japanese' ? '13px' : '12px' }}
                    onClick={handleNewChat}>
                    <img src="./new-chat-white.svg" alt="newChatIcon" ></img>
                    {translate("New chat")}
                  </button>
                  <FeedbackLink translate={translate} langOpt={langOpt} />
                  <AddInfoButton
                    translate={translate}
                    langOpt={langOpt}
                    models={models}
                    modelFilter={modelFilter}
                  />
                  <ManualCoverage translate={translate} langOpt={langOpt} />
                </div>
                <UserHistory openHistory={openHistory} setChildFunc={setChildFunc} setRemoveChatFunc={setRemoveChatFunc} translate={translate} handleNewChat={handleNewChat} setConversationId={setConversationId} />
              </div>
              <Tooltip label={translate("Close Sidebar")} className="tooltip">
                <button className="toggle-sidebar" onClick={toggleSidebar}>
                  <img src={chevronLeft} alt="Collapse Sidebar" />
                </button>
              </Tooltip>
            </aside>
          )}
          <div
            className="resizer"
            onMouseDown={handleMouseDown}
            style={{ cursor: 'col-resize', width: '5px', height: '100%' }}
          ></div>
          <main className={`main ${sidebarVisible ? '' : 'full-width'}`}>
            <div className='main-div' ref={messageSection} id="testing">
              {messages.length === 0 && !isAwaitingResponse && (
                <div className="welcome-screen">
                  {/* <img src={mainChatImg} alt="TIC Chatbot" className="welcome-illustration" /> */}
                  {/* <h2 className="welcome-title">
                    <span className="welcome-underline">{translate("Welcome to the TIC Chatbot Portal")}</span>
                  </h2> */}
                  {/* <p className="welcome-subtitle">
                    {translate("Fuso truck diagnostics, service and repair — expert answers in seconds.")}
                  </p>
                  <p className="welcome-hint">{translate("Please select a model before proceeding.")}</p> */}
                </div>
              )}
              {messages.length > 0 && <div className="chat-window">
                {messages.map((message, index) => (
                  <div key={index} className={`message ${message.role}`}>
                    {message.role === 'assistant' && (
                      <>
                        <img src={fusotransparent} alt="Assistant" />
                        <div className="message-width">
                          <Markdown>
                            {message.streaming
                              ? `${message.content.trimEnd()}<span class="stream-cursor"></span>`
                              : message.content}
                          </Markdown>
                          {message.streaming && (
                            <div className="turn-status">
                              <span className="thinking-text">{translate(turnStatus)}</span>
                              <span className="thinking-dots" aria-hidden="true">
                                <span></span><span></span><span></span>
                              </span>
                            </div>
                          )}
                          {message.streaming && !message.year && !message.casesReady && (
                            <div className="skeleton-row" aria-hidden="true">
                              <span className="skeleton skeleton-case"></span>
                              <span className="skeleton skeleton-case"></span>
                              <span className="skeleton skeleton-case"></span>
                            </div>
                          )}
                          {message.pagesLoading && (
                            <>
                              <div className="turn-status">
                                <span className="thinking-text">{translate(message.pagesStatus || "Fetching Manual Pages")}</span>
                                <span className="thinking-dots" aria-hidden="true">
                                  <span></span><span></span><span></span>
                                </span>
                              </div>
                              <div className="skeleton-row" aria-hidden="true">
                                <span className="skeleton skeleton-page"></span>
                                <span className="skeleton skeleton-page"></span>
                                <span className="skeleton skeleton-page"></span>
                              </div>
                            </>
                          )}
                          {message.noCases && (
                            <div className="turn-status">{translate("No matching past cases found")}</div>
                          )}
                          {message.historyTurn && (
                            <LazyTurnMedia
                              url={HISTORY_TURN_URL}
                              chatId={message.historyTurn.chatId}
                              turnId={message.historyTurn.turnId}
                              onLoaded={attachTurnMedia}
                              label={translate("loading")}
                            />
                          )}
                          <div className='cases'>
                            {message.images && message.images.length > 0 &&
                              dedupeImages(message.images).map((image, index) => (
                                // bro its base64 and width 100px to 50% look good
                                <img
                                  key={index}
                                  src={`data:image/png;base64,${image}`}
                                  alt={`Image ${index + 1}`}
                                  style={{
                                    width: 'auto',      // let it use natural width
                                    height: 'auto',      // let it use natural height
                                    maxWidth: 'none',   // override any global max-width
                                    maxHeight: 'none',   // override any global max-height
                                    margin: '5px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
                                  }}
                                />
                              ))}
                          </div>
                          <div className='cases'>
                            {message.manuals && message.manuals.length > 0 &&
                              dedupeManuals(message.manuals).map((manual, index) => (
                                <React.Fragment key={index}>
                                  {manual.base64_image !== null &&
                                    <img
                                      src={`data:image/png;base64,${manual?.base64_image}`}
                                      alt={`Image ${index + 1}`}
                                      style={{
                                        width: 'auto',
                                        height: '200px', // thumbnail height restricted
                                        maxWidth: '100%',
                                        margin: '5px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        cursor: 'pointer'
                                      }}
                                      onClick={() => {
                                        setSelectedImage(manual.base64_image);
                                        openImageModal();
                                      }}
                                    />}
                                </React.Fragment>
                              ))}
                          </div>
                          {index === messages.length - 1 && (
                            <>
                              <div className='cases'>
                                {solutions && (() => {
                                  // Use sorted order from backend if available, otherwise fallback to Object.keys
                                  const caseOrder = solutions._sorted_order || Object.keys(solutions).filter(key => key !== '_sorted_order');
                                  return caseOrder.filter(caseId => caseId !== '_sorted_order').map((caseId) => (
                                    <button key={caseId} className={`case-button${selectedCase === caseId ? ' active' : ''}`} onClick={() => selectCase(caseId)}>Case {caseId}</button>
                                  ));
                                })()}
                                {dhdSolutions && (() => {
                                  // Use sorted order from backend if available, otherwise fallback to Object.keys
                                  const dhdCaseOrder = dhdSolutions._sorted_order || Object.keys(dhdSolutions).filter(key => key !== '_sorted_order');
                                  return dhdCaseOrder.filter(caseId => caseId !== '_sorted_order').map((caseId) => (
                                    <button key={caseId} className={`case-button${selectedDhdCase === caseId ? ' active' : ''}`} onClick={() => selectDhdCase(caseId)}>{caseId}</button>
                                  ));
                                })()}
                                {dealerSolutions && (() => {
                                  const dealerCaseOrder = dealerSolutions._sorted_order || Object.keys(dealerSolutions).filter(key => key !== '_sorted_order');
                                  return dealerCaseOrder.filter(caseId => caseId !== '_sorted_order').map((caseId) => (
                                    <button key={caseId} className={`case-button${selectedDealerCase === caseId ? ' active' : ''}`} onClick={() => selectDealerCase(caseId)}>
                                      Dealer {caseId}
                                    </button>
                                  ));
                                })()}
                              </div>
                              {message.suggestions && message.suggestions.length > 0 && !isAwaitingResponse && (
                                <div className="suggestion-box">
                                  <span className="suggestion-box-title">{translate("Quick suggestions")}:</span>
                                  <div className="suggestion-chips">
                                    {(() => {
                                      let askIndex = -1;
                                      return message.suggestions.map((s, sIndex) => {
                                        if (s.action !== 'manuals') askIndex += 1;
                                        const chipIcon = suggestionChipIcon(s, Math.max(askIndex, 0));
                                        return (
                                      <button
                                        key={sIndex}
                                        className={`suggestion-chip${s.action === 'manuals' ? ' suggestion-chip-manuals' : ''}`}
                                        onClick={() => {
                                          if (s.action === 'manuals') {
                                            // Phase 2 needs the user to pick a manual
                                            // year — prefill the question and point
                                            // them at the year dropdown.
                                            setQuestion(s.ask || '');
                                            openYearGuide();
                                          } else {
                                            handleSendMessage(s.ask || s.text, s.docs);
                                          }
                                        }}
                                      >
                                        <span className="suggestion-chip-icon">{chipIcon}</span>
                                        {s.text}
                                      </button>
                                        );
                                      });
                                    })()}
                                  </div>
                                </div>
                              )}
                              {selectedCase && solutions[selectedCase] && <div className="solution">
                                <Markdown>{solutions[selectedCase]}</Markdown>
                              </div>}
                              {selectedDhdCase && dhdSolutions[selectedDhdCase] && <div className="solution">
                                <Markdown>{dhdSolutions[selectedDhdCase]}</Markdown>
                              </div>}
                              {selectedDealerCase && dealerSolutions[selectedDealerCase] && <div className="solution">
                                <Markdown>{dealerSolutions[selectedDealerCase]}</Markdown>
                              </div>}
                              {/*<div className='cases'>*/}
                              {/*  {dhdSolutions && (() => {*/}
                              {/*    // Use sorted order from backend if available, otherwise fallback to Object.keys*/}
                              {/*    const dhdCaseOrder = dhdSolutions._sorted_order || Object.keys(dhdSolutions).filter(key => key !== '_sorted_order');*/}
                              {/*    return dhdCaseOrder.filter(caseId => caseId !== '_sorted_order').map((caseId) => (*/}
                              {/*      <button key={caseId} className="case-button" onClick={() => selectDhdCase(caseId)}>{caseId}</button>*/}
                              {/*    ));*/}
                              {/*  })()}*/}
                              {/*</div>*/}
                              {/*{selectedDhdCase !== '' && <div className="solution">*/}
                              {/*  <Markdown>{dhdSolutions[selectedDhdCase]}</Markdown>*/}
                              {/*</div>}*/}
                              {!message.streaming && <div className="actions">
                                {/* <Tooltip label={translate("Good response")} className="tooltip">
                                  <button className="thums" onClick={() => handleFeedback('up')}><img src="./thumsup.svg" alt="thumsUp"></img></button>
                                </Tooltip> */}
                                <Tooltip label={translate("Good response")} className="tooltip">
                                  <button
                                    className={`thums${votedMessages[message.messageId] === 'up' ? ' voted' : ''}`}
                                    disabled={!!votedMessages[message.messageId] || isSubmittingVote}
                                    onClick={() => openVoteModal(message, "up")}
                                  ><img src="./thumsup.svg" alt="thumsUp"></img></button>
                                </Tooltip>
                                <Tooltip label={translate("Bad response")} className="tooltip">
                                  <button
                                    className={`thums${votedMessages[message.messageId] === 'down' ? ' voted' : ''}`}
                                    disabled={!!votedMessages[message.messageId] || isSubmittingVote}
                                    onClick={() => openVoteModal(message, "down")}
                                  ><img src="./thumsdown.svg" alt="thumsDown"></img></button >
                                </Tooltip>
                                <Tooltip label={translate("Save response")} className="tooltip">
                                  <button className="thums" onClick={handleDownload}><img src="./save.svg" alt="saveIcon"></img></button>
                                </Tooltip>
                                <Tooltip label={translate("Copy")} className="tooltip">
                                  <button className="thums" onClick={handleCopy}><img src="./copy.svg" alt="saveIcon"></img></button>
                                </Tooltip>
                                {(!speechPlay && !speechSpinner) && <Tooltip label={translate("Read aloud")} className="tooltip">
                                  <button className="volumeIcon" onClick={fetchAudio} ><img src="./volume.svg" alt="saveIcon"></img></button>
                                </Tooltip>}
                                {speechSpinner && <Tooltip label={translate("loading")} className="tooltip">
                                  <button className="volumeIcon" ><img src="./spinner.gif" alt="spinner"></img></button>
                                </Tooltip>}
                                {(speechPlay && !speechSpinner) && <Tooltip label={translate("stop")} className="tooltip">
                                  <button className="volumeIcon" onClick={handlePause}><img src="./audio-stop.svg" alt="audio"></img><source src={audioSrc} type="audio/wav" /></button>
                                </Tooltip>}
                                <audio ref={audioRef}>
                                  <source src={audioSrc} type="audio/wav" />
                                </audio>
                              </div>}
                            </>
                          )}
                        </div>
                      </>
                    )}
                    {message.role === 'user' && (
                      <div className="message-container">
                        <div className="user-message">
                          {message.content}
                        </div>
                        <img src={profileImage} alt="profile-img"></img>
                      </div>
                    )}
                  </div>
                ))}
              </div>}
              {isAwaitingResponse && !isStreaming && (
                <div className="thinking">
                  <img className="assistant-image" src={fusotransparent} alt="Assistant" />
                  <div className="thinking-body">
                    <span className="thinking-text">{translate(turnStatus)}</span>
                    <span className="thinking-dots" aria-hidden="true">
                      <span></span><span></span><span></span>
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div>
            </div>
            <div className='footer'>
              <div className="filters">
                <div className="select-model" >
                  <Tooltip label={translate("Select Model")} className="tooltip">
                    <div>
                      <CustomSelect
                        emphasis
                        value={modelFilter}
                        onChange={(v) => setModelFilter(v)}
                        placeholder={translate("Select Model")}
                        options={[
                          { value: '', label: translate("Select Model") },
                          ...models.map((model, index) => {
                            const label = modelLabel(model, langOpt); // valueInJap for Japanese, English otherwise
                            return {
                              value: model.valueInJap,
                              label: `${langOpt === "English" ? `${index + 1}. ` : ""}${label}`,
                            };
                          }),
                        ]}
                      />
                    </div>
                  </Tooltip>
                  <label htmlFor='model'>({translate("Mandatory")})</label>
                </div>
                <div className="select-model">
                  <Tooltip label={translate("Select Engine")} className="tooltip">
                    <div>
                      <CustomSelect
                        value={engineFilter}
                        onChange={(v) => setEngineFilter(v)}
                        placeholder={translate("Select Engine")}
                        disabled={selectedYear !== ""}
                        options={[
                          { value: '', label: translate("Select Engine") },
                          ...engineModels.map((engine) => ({ value: engine, label: engine })),
                        ]}
                      />
                    </div>
                  </Tooltip>
                  <label htmlFor='engine'>({translate("Optional")})</label>
                </div>
                <div className="select-model">
                  <Tooltip label={translate("Select the year of the maintenance manual")} className="tooltip">
                    <div>
                      <CustomSelect
                        value={selectedYear}
                        onChange={(v) => setSelectedYear(v)}
                        placeholder={translate("Select the year of the maintenance manual")}
                        disabled={engineFilter !== "" || availableYears.length === 0}
                        options={[
                          { value: '', label: translate("Select the year of the maintenance manual") },
                          ...availableYears
                            .slice()
                            .sort((a, b) => Number(b) - Number(a))
                            .map((year) => ({ value: year, label: year })),
                        ]}
                      />
                    </div>
                  </Tooltip>
                  <label htmlFor='year'>({translate("Optional")})</label>
                </div>
              </div>
              {isBotLooking && <img className={`bot-gif ${isBotLooking ? "bot-gif-visible" : ""}`} src="./bot.gif" alt="bot-gif"></img>}
              <div className='question'>
                <img className="input-logo" src={fusotransparent} alt="Assistant" />
                <input
                  type="text"
                  value={question}
                  onChange={handleChange}
                  placeholder={translate("How can I assist you today?")}
                  className="input-question"
                  onKeyPress={handleKeyPress}

                  onBlur={handleBlur}
                />
                <Dictaphone setQuestion={setQuestion} langOpt={langOpt} />
                <button
                  onClick={handleSendMessage}
                  className={`send-button ${isAwaitingResponse ? 'awaiting-response' : ''}`}
                  disabled={isAwaitingResponse}
                >
                  <img src={sendIcon} alt="Send" className="send-icon" />
                </button>
              </div>
            </div>
          </main>
          {!sidebarVisible && (
            <button className="toggle-sidebar-collapsed" onClick={toggleSidebar}>
              <img src={chevronRight} alt="Expand Sidebar" />
            </button>
          )}

        </div>
      </div>
      <ImageModal imageSrc={selectedImage} isOpen={isImageModalOpen} onClose={closeImageModal} />
    </>
  );
}

export default App;
